import { AssetAbridged } from '../abridged/asset-abridged.model';
import { SiteAbridged } from '../abridged/site-abridged.model';
import { WorkflowItem } from './workflow-item.model';

export class AssetScheduleDeleteWorkflowItem extends WorkflowItem {
  reason: string;
  assetAvailabilityId: number;
  site: SiteAbridged;
  asset: AssetAbridged;
  worker: string;
  startTime: string;
  endTime: string;

  public deserialize(input: any): this {

    super.deserialize(input);
    this.reason = input.reason;
    this.startTime = input.assetAvailabilityWindow.startTime;
    this.endTime = input.assetAvailabilityWindow.endTime;
    const startTime = new Date(input.assetAvailabilityWindow.startTime);
    const endTime = new Date(input.assetAvailabilityWindow.endTime);

    const optionsDate = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    };

    const optionsTime = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
      timeZone: 'Europe/London'
    };

    const formattedStartDate = startTime.toLocaleString('en-GB', optionsDate as Intl.DateTimeFormatOptions);
    const formattedEndDate = endTime.toLocaleString('en-GB', optionsDate as Intl.DateTimeFormatOptions);
    const formattedStartTime = startTime.toLocaleString('en-GB', optionsTime as Intl.DateTimeFormatOptions);
    const formattedEndTime = endTime.toLocaleString('en-GB', optionsTime as Intl.DateTimeFormatOptions);

    if (formattedStartDate !== formattedEndDate) {
      this.details = `${formattedStartDate}, ${formattedStartTime} - ${formattedEndDate}, ${formattedEndTime}`;
    } else {
      this.details = `${formattedStartDate}, ${formattedStartTime} - ${formattedEndTime}`;
    }

    this.assetAvailabilityId = input.assetAvailabilityWindow.id;
    this.asset = new AssetAbridged().deserialize( { id: input.assetAvailabilityWindow.assetId, name: input.assetAvailabilityWindow.assetName} );
    this.site = new SiteAbridged().deserialize( { id: input.assetAvailabilityWindow.siteId, name: input.assetAvailabilityWindow.siteName} );

    return this;
  }

  public getTaskDetails(): string {
    return `CANCELLATION - Asset Schedule Cancellation needs approval on site: ${this.site.name}, asset: ${this.asset.name}`;
  }

  public getStartDateWithoutTime(): string {
    return this.startTime.slice(0, 10);
  }
};
